import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import { useFlightDeck } from 'src/context/FlightDeckContext'
import RouteContainer from 'src/components/App/RouteContainer'

const WorkflowCreateForm = React.lazy(() => loadComponent('traiwiss', 'WorkflowCreateForm'))

export function WorkflowCreateRoute() {
    const navigate = useNavigate()
    const { academy } = useFlightDeck()

    const onCreate = useCallback(() => {
        navigate('/workflows')
    }, [navigate])

    const onClose = useCallback(() => {
        navigate('/workflows')
    }, [navigate])

    return (
        <RouteContainer>
            <WorkflowCreateForm academyId={academy?._id} onCreated={onCreate} onClosed={onClose} />
        </RouteContainer>
    )
}
